import { render, staticRenderFns } from "./SelectClass.vue?vue&type=template&id=5ec8afbc&scoped=true"
import script from "./SelectClass.vue?vue&type=script&lang=js"
export * from "./SelectClass.vue?vue&type=script&lang=js"
import style0 from "./SelectClass.vue?vue&type=style&index=0&id=5ec8afbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8afbc",
  null
  
)

export default component.exports